export const ProvidersIds = {
  ROSCLUSTER_ID: '526234b0e0e34c4743821ab4',
};
